import { useEffect, useState } from 'react';
import { useInterval } from 'react-use';

import { useFeatureFlag } from '@/utils/hooks';
import useUser from '@/utils/hooks/swr/useUser';

import { post } from '@/utils/client';

import { HUBSPOT_CONVERSATION_TOKEN } from '@/lib/routes/apiEndpoints';

const HUBSPOT_SCRIPT_ID = 'hs-script-loader';
const HUBSPOT_SCRIPT_LOAD_DELAY = 500;

export default function HubSpotIdentification() {
    const isAiAgentActive = useFeatureFlag('ai_agent_active');
    const { user } = useUser();

    const [isLoaded, setIsLoaded] = useState(false);

    const createToken = async () => {
        return await post(HUBSPOT_CONVERSATION_TOKEN).then((response) => response.data?.token);
    };

    const loadWidget = async () => {
        const token = user.first_name && user.last_name ? await createToken() : null;

        if (!token) {
            return;
        }

        window.HubSpotConversations?.clear?.({ resetWidget: true });
        window.hsConversationsSettings = {
            ...window.hsConversationsSettings,
            identificationEmail: user.email,
            identificationToken: token
        };

        /**
         * When AI agent flag is active
         * Widget is loaded when user clicks the custom "Need support" button, not here.
         */
        if (!isAiAgentActive) {
            window.HubSpotConversations?.widget?.load?.();
        }
    };

    useEffect(() => {
        // Prevent widget from loading automatically so it can be opened via custom button only.
        window.hsConversationsSettings = {
            ...window.hsConversationsSettings,
            loadImmediately: false
        };
        if (!user) {
            window.HubSpotConversations?.widget?.remove?.();
            window.HubSpotConversations?.clear?.({ resetWidget: true });
            window.HubSpotConversations?.widget?.refresh?.({ openToNewThread: true });
            return;
        }
        if (!isLoaded) return;

        // Set identification only; do not call widget.load() — widget is loaded on custom button click.
        loadWidget();
    }, [user?.email, isLoaded]);

    useInterval(
        () => {
            if (document?.getElementById(HUBSPOT_SCRIPT_ID)) {
                setIsLoaded(true);
            }
        },
        isLoaded ? null : HUBSPOT_SCRIPT_LOAD_DELAY
    );

    return null;
}
